export default class Svg {
  static fix(svg, width = 200, height = 200) {
    if (!svg) {
      return null;
    }
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(svg, "text/html");
    let rectangles = htmlDoc.getElementsByTagName("rect");
    for (let i = 0; i < rectangles.length; i++) {
      if (rectangles[i].getAttribute("width") < 0) {
        const x = parseFloat(rectangles[i].getAttribute("x"));
        const width = parseFloat(rectangles[i].getAttribute("width"));
        rectangles[i].setAttribute("x", x + width);
        rectangles[i].setAttribute("width", Math.abs(width));
      }
    }
    htmlDoc.getElementsByTagName("svg")[0].setAttribute("width", width + "px");
    htmlDoc.getElementsByTagName("svg")[0].setAttribute("height", height + "px");
    return htmlDoc.getElementsByTagName("svg")[0].outerHTML;
  }

  static highlighByCode(svg, code, color = "#14c944"){
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(svg, "text/html");
    let rectangles = htmlDoc.getElementsByTagName("rect");
    for (let i = 0; i < rectangles.length; i++) {
      if (rectangles[i].getAttribute("id") == code) {
        rectangles[i].setAttribute("fill", color);
        break;
      }
    }
    return htmlDoc.getElementsByTagName("svg")[0].outerHTML;
  }
}
